export default "__VITE_ASSET__CSi1W$xw__"